import { useQuery } from '@tanstack/react-query';
import { getListNames } from 'Services';
import { RQ_LIST_ENTRIES } from 'Utils';

function useGetListNames() {
    return useQuery([RQ_LIST_ENTRIES], () => getListNames());
}

export default useGetListNames;
